import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const TypeChademoIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 24 24" fill="none" {...rest}>
        <g clipPath="url(#clip0_8_10948)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.454 21.797A11.8 11.8 0 0 0 12 23.782 11.79 11.79 0 0 0 23.782 12c0-2.05-.534-4.059-1.544-5.832l1.087-2.103L20.138.862 18.1 1.92a11.79 11.79 0 0 0-12.177-.015L3.937.87.75 4.065l1.054 2.03a11.78 11.78 0 0 0 3.65 15.702Zm10.896-6.542a3.592 3.592 0 1 1 3.592-3.593 3.6 3.6 0 0 1-3.592 3.593Zm-6.08-7.532a2.505 2.505 0 1 0 2.784-4.166 2.505 2.505 0 0 0-2.784 4.166Zm-3.288 7.532a3.592 3.592 0 1 1 3.592-3.593 3.6 3.6 0 0 1-3.592 3.593Zm4.68 5.603a2.505 2.505 0 1 1 2.314-1.54 2.5 2.5 0 0 1-2.314 1.54Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_8_10948">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </Svg>
);
